<script lang="ts">
	/**
	 * Skeleton rows for a data table. Renders bare `<tr>` elements, so it drops
	 * straight inside a Flowbite `<TableBody>` where a component wrapper would
	 * break the table's element nesting.
	 *
	 * A table swapping between a single centred spinner and a full body is the
	 * most jarring load in the app — the page height doubles in one frame. Rows
	 * of the right count and column width hold the layout still instead.
	 *
	 * Bar widths cycle through a fixed set so the block looks like data rather
	 * than a striped pattern, without needing randomness (which would reshuffle
	 * on every re-render).
	 */

	/** How many skeleton rows to draw — match your page size. */
	export let rows: number = 5;

	/** How many cells per row — match your header cell count. */
	export let columns: number = 4;

	/** Row height class, applied to the cells. */
	export let cellClass: string = 'px-4 py-3';

	const barClass = 'h-2.5 bg-gray-300 rounded-full dark:bg-gray-700';
	const widths: string[] = ['w-3/4', 'w-1/2', 'w-5/6', 'w-2/3', 'w-1/3', 'w-4/5'];
</script>

<!--
	The cell count must stay exactly `columns` — an extra cell for the screen
	reader text would knock every column out of alignment, so the announcement
	lives inside the first cell instead.
-->
{#each Array(rows) as _, rowIndex}
	<tr class="animate-pulse">
		{#each Array(columns) as _, columnIndex}
			<td class={cellClass}>
				{#if rowIndex === 0 && columnIndex === 0}
					<span class="sr-only" role="status">Loading...</span>
				{/if}
				<div class="{barClass} {widths[(rowIndex + columnIndex) % widths.length]}" />
			</td>
		{/each}
	</tr>
{/each}
